<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        Site Info
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WebCastle</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Site</a>
        </li>
      </ul>
    </div>
    <quick-setup @refresh="refresh" v-if="is_first" @count="x => this.$emit('count', x)"></quick-setup>
    <b-row v-else>
      <b-col lg="12" :xl="isLoadPolicy ? 8 : 12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              Site Info <span v-if="!add && model.created_at">( Registered : {{model.created_at | sdate}})</span>
            </div>
            <div class="mb7">
              <span class="float-right" v-if="!add && model.last_visit">Last Visit : {{model.last_visit | utcsdate}}</span>
              <span class="float-right" v-else> - </span>
            </div>
          </div>
          <hr>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" v-if="add" style="cursor:pointer">
              <label class="col-form-label" for="ph_use" v-b-tooltip.hover title="Start site registration and check">
                Start with registration
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center" v-if="add" style="cursor:pointer">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Allow_login" id="Allow_login"  v-model="model.is_start" :disabled="lock">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" label-for="ph_use" v-b-tooltip.hover title="Set scan enable or disable">
              <label class="col-form-label" for="ph_use">
                Enable  <i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="ph_use" id="Allow_login" v-model="model.is_alive" :disabled="lock">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" label-for="ph_use" v-b-tooltip.hover title="Toggle js click event trigger">
              <label class="col-form-label" for="ph_use">
                is_js <i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="ph_use" id="Allow_login" v-model="model.is_alive" :disabled="lock">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center" label-for="ph_use" v-b-tooltip.hover title="Set Login enable or disable">
              <label class="col-form-label" for="ph_use">
                is_login  <i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="ph_use" id="Allow_login" v-model="model.is_login" :disabled="lock">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2" v-show="!lock">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_schedule_type" v-b-tooltip.hover title="Specify a check policy, the policy must be pre-generated">
                Check Policy<i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-select v-model="model.policy_id" @change="change($event)" :disabled="lock" ref="policy">
                <option v-for="item in policy_list" :key="item.id" :value="item.id">{{item.description ? item.description : item.policy.description}}</option>
              </b-form-select>
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username" v-b-tooltip.hover title="Specifies the name that separates the site">
                Name <i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-input placeholder="Auto Fill when write FQDN input" type="text" id="ph_name" v-model="model.name" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2" v-show="!add && lock">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" v-b-tooltip.hover title="Specify a check policy, the policy must be pre-generated">
                Check Policy <i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              {{policy.description}}
            </b-col>
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_username" v-b-tooltip.hover title="Specifies the name that separates the site">
                Name <i style="cursor:pointer" class="fa fa-question-circle"></i>
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-input placeholder="Auto Fill when write FQDN input" type="text" id="ph_name" v-model="model.name" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <b-form-group>
                <label class="col-form-label">
                  FQDN : ex) www.f1security.co.kr : www(host) + f1security.co.kr(domain)
                </label>
                <b-input-group class="text-center">
                  <b-input-group-prepend><b-input-group-text> FQDN </b-input-group-text></b-input-group-prepend>
                  <b-form-input class="text-center border form-control" type="text" ref="fqdn" id="ph_fqdn" placeholder="FQDN (ex : www.company.com)" v-model="model.fqdn" :plaintext="lock" @change="check_fqdn"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <label
                style="cursor:pointer"
                @click="msg = 'URLs to be checked or main pages to be checked or URLs of pages to be checked.'; modal_explain = true"
              >
                Check Start URL (max 10)
                <i class="fa fa-question-circle"></i>
              </label>
              <b-form-group>
                <b-input-group>
                  <b-input-group-prepend><b-input-group-text> Start From </b-input-group-text></b-input-group-prepend>
                  <b-form-input class="text-center border form-control" id="ph_seed" v-model="v.seed" type="url" placeholder="Full URL, ex) https://f1security.co.kr" @keyup.native.enter="add_seed()" :disabled="lock || (model.config.seeds.length >= 10)"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="add_seed()" :disabled="lock || (model.config.seeds.length >= 10)">Add</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-list-group>
                  <b-list-group-item v-for="(seed, index) in model.config.seeds" :key="index"><i class="fa fa-times" @click="remove_seed(seed)" v-show="!lock"></i> {{seed}}</b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label
                  style="cursor:pointer"
                  @click="msg = 'Set the inspection cycle, It is recommended that you check at least once a day at a time when there are fewer people accessing the site.'; modal_explain = true"
                >
                  Check Schedule
                  <i
                  style="cursor:pointer"
                  class="fa fa-question-circle"
                  ></i>
                </label>
                <small>Max :{{max_schedule}}</small>
                <br>
                * <b-badge variant="warning">Notice</b-badge>
                : For a your site availability, limit the maximum number of checks per day
                <hr>
                <b-input-group>
                  <b-form-select ref="schedule" id="ph_schedule" v-model="s.h" :options="s.h_opt" :disabled="lock" @change="schedule($event, 'h')"></b-form-select>
                  <b-form-select v-model="s.m" :options="s.m_opt" :disabled="lock" @change="schedule($event, 'm')"></b-form-select>
                  <b-input-group-append>
                    <b-button variant="primary" @click="add_schedule" :disabled="lock || (model.schedule.length >= max_schedule)">Add</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <!-- // TODO : 나중에 크론 문법 아는 사람들을 위해 제공 예정 -->
              <!-- <b-form-group>
                <b-input-group>
                    <b-input-group-prepend><b-input-group-text>Custom Schedule(Use Cron Grammar) </b-input-group-text></b-input-group-prepend>
                    <b-form-input id="ph_schedule_custom" v-model="s.schedule_custom" type="text" placeholder="ex) 0 0 * * * *" @keyup.native.enter="add_schedule_custom" :disabled="lock || (model.schedule.length >= max_schedule)"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="add_schedule_custom" :disabled="lock || (model.schedule.length >= max_schedule)">Add</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group> -->
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b-list-group>
                  <b-list-group-item v-for="(schedule, index) in model.schedule" :key="index">
                    <i class="fa fa-times" @click="remove_schedule(schedule)" v-if="!lock"></i>
                    ({{ schedule }}) {{ schedule | cron_filter }}
                  </b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <strong>Additional information</strong>
          <b-row class="mt-3">
            <b-col md="6">
              <b-form-group>
                <label
                  style="cursor:pointer"
                  for="ph_sub_domain"
                  @click="msg = 'Register if subdomain exists within the same site ex) admin.f1security.co.kr'; modal_explain = true"
                >
                  Sub Domain
                  <i class="fa fa-question-circle"></i>
                </label>
                <b-input-group>
                  <b-form-input id="ph_sub_domain" v-model="v.sub" type="text" ref="sub_domains" placeholder="Domain" @keyup.native.enter="add_sub" :disabled="lock || (model.config.subs.length >= 100)"></b-form-input>
                  <b-button variant="primary" @click="add_sub" :disabled="lock || (model.config.subs.length >= 100)">Add</b-button>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-list-group>
                  <b-list-group-item v-for="(sub, index) in model.config.subs" :key="index"><i style="cursor:pointer" class="fa fa-times" v-show="!lock" @click="remove_sub(sub)"></i> {{sub}}</b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label
                  style="cursor:pointer"
                  for="ph_prevent"
                  @click="msg = 'Specifies the path to which the exception should be processed ex)/admin/download'; modal_explain = true">
                  Exception Path
                  <i class="fa fa-question-circle"></i>
                </label>
                <b-input-group>
                  <b-form-input id="ph_prevent" v-model="v.prevent" ref="prevent" type="text" placeholder="subroutine path" @keyup.native.enter="add_prevent" :disabled="lock || (model.config.prevenlength >= 100)"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="primary" @click="add_prevent" :disabled="lock || (model.config.prevenlength >= 100)">Add</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <b-form-group>
                <b-list-group>
                  <b-list-group-item v-for="(prevent, index) in model.config.prevents" :key="index"><i style="cursor:pointer" class="fa fa-times" v-show="!lock" @click="remove_prevent(prevent)"></i> {{prevent}}</b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group>
                <label
                  style="cursor:pointer"
                  for="regex"
                  @click="msg = 'Enter a word to be treated as an exception with a regular Expression(can match the parts) ex) (edit | remove)'; modal_explain = true"
                >
                  Exception Regex
                  <i class="fa fa-question-circle"></i>
                </label>
                <b-input-group>
                  <b-form-input id="regex" v-model="model.regex" type="text" ref="regex" placeholder="support regex format" :disabled="lock"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="lock">
            <template v-if="model.is_del">
              <!-- <b-button size="sm" variant="success" @click="revive"> Recover </b-button> -->
            </template>
            <template v-else>
              <b-button size="sm" variant="warning" @click="edit"> Edit </b-button>
              <b-button size="sm" variant="danger" @click="del_confirm = true"> Remove </b-button>
            </template>
          </template>
          <template v-else>
            <b-button size="sm" variant="add" @click="() => model.id ? save() : modal_charge_agree = true"> Save </b-button>
            <b-button size="sm" variant="secondary" @click="cancel"> Cancel </b-button>
          </template>
          <b-button size="sm" class="float-right text-white" variant="primary" @click="list"> List </b-button>
        </b-card>
      </b-col>
      <!-- policy start -->
      <b-col lg="12" xl="4" v-if="isLoadPolicy">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              Policy
            </div>
            <div class="mb7">
              <small class="float-right">info read only</small>
            </div>
          </div>
          <hr>
          <b-row class="text-center">
            <b-col md="12">
              <span block class="h5">{{ isLoadPolicy ?  policy.description : '-'}}</span>
              <hr>
              <small>
                This page is Only showing policy information, can change on policy edit page.
              </small>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="12">
              <b-form-group v-b-tooltip.hover :title="`Enter whether to check by moving (path) the link from the first page to the next. The default value for Quick Setup is ${policy.depth}`" class="text-center">
                <b-input-group-prepend><b-input-group-text> Maximum path depth &nbsp;<i style="cursor:pointer" class="fa fa-question-circle"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input :disabled="true" class="text-center border" type="number" id="ph_depth" :min="1" :max="100" v-model="policy.depth" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                class="text-center"
                v-b-tooltip.hover:title="`
                  Enter the maximum sublink to navigate within a page.
                  Ignore any excess links.
                  Normally if too many links exist on one page, you can reach the maximum navigation page before navigating to the other to prevent it from not being checked in a balanced way.
                  The default value for Quick Setup is ${policy.links}`"
              >
                <b-input-group-prepend><b-input-group-text> Sub Page Link &nbsp;<i style="cursor:pointer" class="fa fa-question-circle"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="1" :max="1000" v-model="policy.links" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group 
                class="text-center"
                v-b-tooltip.hover:title="`
                  Total number of pages to check on the inspection site.
                  End the check when the entered number is reached.
                  can be specified within the range of 1 to license limit.
                  The default value for Quick Setup is ${policy.limit}`"
              >
                <b-input-group-prepend><b-input-group-text> Maximum Navigation Page &nbsp;<i style="cursor:pointer" class="fa fa-question-circle"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input :disabled="true" class="text-center border" type="number" id="ph_limit" :min="10" :max="50000" v-model="policy.limit" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
               class="text-center"
               v-b-tooltip.hover:title="`
                Time to wait for page loading.
                can be specified within the range of 1-30.
                The default value for Quick Setup is ${policy.timeout}`"
              >
                <b-input-group-prepend><b-input-group-text> TimeOut(Seceond) &nbsp;<i style="cursor:pointer" class="fa fa-question-circle"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input :disabled="true" class="text-center border" type="number" id="ph_timeout" :min="1" :max="30" v-model="policy.timeout" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                class="text-center"
                v-b-tooltip.hover:title="`
                  Time to wait before moving to a new page.
                  can be specified within the range of 1 to 10 000.
                  The default value for Quick Setup is ${policy.delay}`"
              >
                <b-input-group-prepend><b-input-group-text> Check Speed(Millisecond) &nbsp;<i style="cursor:pointer" class="fa fa-question-circle"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input :disabled="true" class="text-center border" type="number" id="ph_links" :min="0" :max="10000" v-model="policy.delay" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <template>
            <b-button block size="sm" variant="add" @click="policy_manage"> Manage </b-button>
          </template>
        </b-card>
        <!-- result start -->
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="d-flex flex-wrap align-items-center">
              <div class="title mr-auto mb7">
                <span v-if="result.page_count > 0">Have the latest inspection results.</span>
                <span v-else>Don't have a recent check history.</span>
              </div>
            </div>
          </div>
          <hr>
          <template>
            <b-button :disabled="!(result.page_count > 0)" block size="sm" variant="warning" @click="confirm_result = true"> Check it </b-button>
          </template>
        </b-card>
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              <span>Displays whether login checks are enabled </span>
            </div>
          </div>
          <hr>
            <template>
              <b-button :disabled="!is_using_login" block size="sm" :variant="is_using_login ? 'add' : 'secondary'"> {{ is_using_login ? 'Enable' : 'Disable' }} </b-button>
            </template>
          </b-card>
      </b-col>
    </b-row>
    <!-- delete modal -->
    <b-modal title="Delete"  class="modal-danger" v-model="del_confirm" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="outline-danger" cancel-variant="outline-dark">
      <p> Delete registered sites for checks </p>
      <p>
        If it is deleted, it is not possible to check the distribution location of the malicious code and its suspension.
      </p>
      <p> <b> * Check Site Name </b> </p>
      <p> Delete Site Name : {{model.name}}  </p>
      <b-form-input v-model="del_nickname" placeholder="Typing The name of the server you want to unregister"></b-form-input>
    </b-modal>
    <!-- result modal -->
    <b-modal size="xl" title="Site Result" v-model="confirm_result" hide-footer @ok="confirm_result = false" ok-variant="outline-primary">
      <result :result_id="result.id" :site="model"></result>
    </b-modal>
    <!-- modal -->
    <b-modal size="xs" title="Information" v-model="modal_explain" hide-footer ok-variant="add">
      {{msg}}
    </b-modal>
    <b-modal v-model="modal_charge_agree" title="Controls all agents" @ok="charge_agree" no-close-on-backdrop header-bg-variant="warning">
      <h5>Charging will begin when the first site registration is made and scanning started.</h5>
      <hr>
      <a target="_blank" :href="redir" class="card-link">
        <span class="text-dark">See More</span>
        <i class="fa fa-share"></i>
        {{redir}}
      </a>
      <hr>
      <h6> <b>Are you sure argree?</b></h6>
    </b-modal>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>